import { createNativeStackNavigator } from '@react-navigation/native-stack';
import CategoryScreen from 'screens/Category';
import DownloadAppScreen from 'screens/DownloadApp';
import TvEasterEggScreen from 'screens/EasterEgg/index.ctv';
import FavoritesScreen from 'screens/Favorites';
import ContactUsScreen from 'screens/Help/ContactUsScreen';
import TvContactUsScreen from 'screens/Help/ContactUsScreen.ctv';
import FAQSectionScreen from 'screens/Help/FAQSectionScreen';
import TvFAQSectionScreen from 'screens/Help/FAQSectionScreen.ctv';
import LegalTermsScreen from 'screens/Help/LegalTermsScreen';
import TvLegalTermsScreen from 'screens/Help/LegalTermsScreen.ctv';
import TvMyProfile from 'screens/Help/MyProfile.ctv';
import HomeScreen from 'screens/Home/HomeScreen';
import ProgramScreen from 'screens/Program/ProgramScreen';
import SearchScreen from 'screens/Search';
import WebViewScreen from 'screens/WebView';
import AnalyticsScreen from 'services/analytics/Screen';
import { Platform } from 'utils/platform';

import Header from 'components/Header';

const Stack = createNativeStackNavigator();

export const MainStack = () => {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false, animation: 'none' }}>
      <Stack.Screen
        name="Home"
        component={HomeScreen as any}
        getId={({ params }: any) => params?.id}
        options={{
          title: 'Bandplay',
          header: ({ options }) => <Header title={options.title} showScreenName />,
          headerShown: !Platform.isTV,
        }}
      />
      <Stack.Screen
        name="Videos"
        component={HomeScreen as any}
        initialParams={{ id: 'assista' }}
        getId={({ params }) => params?.id}
        options={{
          title: 'Bandplay',
          header: ({ options }) => <Header title={options.title} showScreenName />,
          headerShown: !Platform.isTV,
        }}
      />
      <Stack.Screen
        name="Listen"
        initialParams={{ id: 'ouca' }}
        component={HomeScreen as any}
        getId={({ params }) => params?.id}
        options={{
          title: 'Bandplay',
          header: ({ options }) => <Header title={options.title} showScreenName />,
          headerShown: !Platform.isTV,
        }}
      />
      <Stack.Screen
        name="Generic"
        component={HomeScreen as any}
        getId={({ params }) => params?.id}
        options={{
          header: ({ options }) => <Header title={options.title} showScreenName />,
          headerShown: !Platform.isTV,
        }}
      />
      <Stack.Screen
        name="Program"
        component={ProgramScreen}
        getId={({ params }) => params.programId}
      />
      <Stack.Screen
        name="Category"
        getId={({ params }) => params?.slug}
        component={CategoryScreen}
        options={{
          header: ({ options }) => <Header title={options.title} showScreenName />,
          headerShown: !Platform.isTV,
        }}
      />
      <Stack.Screen
        name="Search"
        component={SearchScreen}
        options={{
          title: 'Buscar - Bandplay',
          header: ({ options }) => <Header title={options.title} showScreenName />,
          headerShown: !Platform.isTV,
        }}
      />
      <Stack.Screen
        name="WebView"
        component={WebViewScreen}
        options={{
          title: 'Band +',
          header: ({ options }) => <Header title={options.title} showScreenName />,
          headerShown: !Platform.isTV,
        }}
      />
      <Stack.Screen
        name="Favorites"
        component={FavoritesScreen}
        options={{
          title: 'Minha lista',
          header: ({ options }) => <Header title={options.title} showScreenName />,
          headerShown: !Platform.isTV,
        }}
      />
      <Stack.Group
        screenOptions={{
          header: () => <Header showScreenName />,
          headerShown: !Platform.isTV,
        }}>
        <Stack.Screen
          name="FaqSection"
          component={Platform.isTV ? TvFAQSectionScreen : FAQSectionScreen}
        />
        <Stack.Screen
          name="LegalTerms"
          component={Platform.isTV ? TvLegalTermsScreen : LegalTermsScreen}
        />
        <Stack.Screen
          name="ContactUs"
          component={Platform.isTV ? TvContactUsScreen : ContactUsScreen}
        />
      </Stack.Group>
      <Stack.Screen name="MyProfile" component={TvMyProfile} />
      {Platform.OS === 'web' && !Platform.isTV && (
        <Stack.Screen
          name="DownloadApp"
          component={DownloadAppScreen}
          options={{ title: 'Baixe o app Bandplay' }}
        />
      )}
      {__DEV__ && <Stack.Screen name="Analytics" component={AnalyticsScreen} />}
      {Platform.isTV && <Stack.Screen name="EasterEgg" component={TvEasterEggScreen} />}
    </Stack.Navigator>
  );
};
